<template>
    <BaseChart
    :type="type"
    :data="data"
    :h="h"
    :max_height="max_height"
    :min_height="min_height"
    :scale="scale"
    :theme="theme"
    :theme_obj="theme_obj"
    @renderCompalte="(value) => renderCompalte(value)"/>
</template>

<script>


import eBase from '@/base/eBase';

import BaseChart from '@/components/common/BaseChart.vue';

export default {

  components: {
    BaseChart,
  },

  props: {
    method: { required: false, default: 'get' },
    options: {
      required: false,
      default() {
        return {};
      },
    },
    type: { required: true },
    url: { required: true },
    h: { required: false },
    max_height: { required: false },
    min_height: { required: false },
    scale: { required: false, default: '420%' },
    theme: { required: false, default: 'bar' },
    theme_obj: { required: false, default: undefined },
    renderInMounted: { required: false, default: true },
    originData: null, // 外部传入数据
  },

  data() {
    return {
      data: {},
    };
  },

  beforeMount() {
    eBase.debug('[chart.vue][beforeMount][enter]');
  },

  mounted() {
    eBase.debug('[chart.vue][mounted][enter]');

    this.renderInMounted && this.query(this.options);
  },

  updated() {

  },

  beforeDestroy() {

  },

  watch: {
    options: {
      handler(newValue) {
        this.query(newValue);
      },
      immediated: true,
      deep: true,
    },
  },

  computed: {
  },

  methods: {

    addListeners() {

    },

    query(opt) {
      if (!this.originData) {
        eBase.send({ url: this.url, params: opt }, this.method).then((res) => {
          this.data = res.data.data;
          this.$emit('afterFetch', this.data);
        });
      } else {
        this.data = this.originData;
      }
    },

    refresh() {
      this.query(this.options);
    },

    renderCompalte(title) {
      this.$emit('renderCompalte', title);
    },

  }, // EOF method
};
</script>



// WEBPACK FOOTER //
// src/components/common/Chart.vue